import React from "react";
import { Box } from "@mui/material";
import { ThreeDot } from 'react-loading-indicators';

// Loading Element
const LoadingOverlay = ({ type }) => {
    return (
        <Box sx={{ width: "100%", height: "20vh", justifyContent: "center", alignItems: "center", display: "flex" }}>
            <ThreeDot
                variant="bounce"
                color="#a871e3"
                size="large"
                textColor="#c530ff"
            />
        </Box>
    );
};

export default LoadingOverlay;
